import axios from 'axios'
// Admin operations
const adminOps = (requestObj) => {
  return axios
  .post(`${process.env.VUE_APP_API_ENDPOINT}/api/account/adminOps`, requestObj)
  .then(({ data }) => {      
    return data;
  })
  .catch(error => {
    console.log(`###API AdminOps Error: ${error}`);
    // return error;
    throw error;
  });
};
// Change record status
const changeUserStatus = (requestObj) => {
  return axios
  .patch(`${process.env.VUE_APP_API_ENDPOINT}/api/changeUserStatus/${requestObj.recordId}`, {
    disable: requestObj.disable
  })
  .then(({ data }) => {      
    return data;
  })
  .catch(error => {
    console.log(`###API Change User Status Error: ${error}`);
    throw error;
  });
};
// Fetch super admin users
const fetchAdminUsers = () => {
  return axios
  .get(`${process.env.VUE_APP_API_ENDPOINT}/api/adminusers`)
  .then(({ data }) => {      
    return data;
  })
  .catch(error => {
    console.log(`###API Fetchh Super Admin Users Error: ${error}`);
    throw error;
  });
};
// Fetch user company details
const fetchCompanyDetails = (requestObj) => {
  return axios[requestObj.method](`${process.env.VUE_APP_API_ENDPOINT}/api/fetchCompanyDetails/${requestObj.accountId}`, requestObj.data)
  .then(({ data }) => {   
    return data;
  })
  .catch(error => {
    console.log(`###API Fetch Company Details Error: ${error}`);
    throw error;
  });
};
export default {
  adminOps,
  changeUserStatus,
  fetchAdminUsers,
  fetchCompanyDetails
};
